import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nb_noCommon from "./nb_no/common.json";
import nn_noCommon from "./nn_no/common.json";
import enCommon from "./en/common.json";
import frCommon from "./fr/common.json";
import esCommon from "./es/common.json";
import deCommon from "./de/common.json";
import svCommon from "./sv/common.json";
import plCommon from "./pl/common.json";
import seCommon from "./se/common.json";
import smaCommon from "./sma/common.json";
import smsCommon from "./sms/common.json";
import smjCommon from "./smj/common.json";

/** Texts not translated yet start with this marker (followed by the source text). They are left out, so the fallback language is used */
export const UNTRANSLATED_MARKER = "[not translated]";

/**
 * Leave out texts that start with the untranslated marker
 * @param {object} texts A language's texts
 * @returns {object} The translated texts
 */
const withoutUntranslated = (texts: Record<string, string>): Record<string, string> =>
  Object.fromEntries(Object.entries(texts).filter(([, value]) => !value.startsWith(UNTRANSLATED_MARKER)));

/**
 * I18n language configuration settings
 */
export const resources = {
  no: { common: withoutUntranslated(nb_noCommon) },
  nb: { common: withoutUntranslated(nb_noCommon) },
  nn: { common: withoutUntranslated(nn_noCommon) },
  sv: { common: withoutUntranslated(svCommon) },
  en: { common: withoutUntranslated(enCommon) },
  de: { common: withoutUntranslated(deCommon) },
  fr: { common: withoutUntranslated(frCommon) },
  es: { common: withoutUntranslated(esCommon) },
  pl: { common: withoutUntranslated(plCommon) },
  se: { common: withoutUntranslated(seCommon) },
  sma: { common: withoutUntranslated(smaCommon) },
  sms: { common: withoutUntranslated(smsCommon) },
  smj: { common: withoutUntranslated(smjCommon) }
};

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    react: {
      useSuspense: false,
    },
    fallbackLng: {
      'no': ['nb', 'nn'],
      'nb': ['sv', 'en'],
      'nn': ['nb'],
      'sv': ['nb', 'en'],
      'en': ['fr', 'nb', 'sv'],
      'se': ['nb', 'sv', 'en'],
      'sma': ['sv', 'nb', 'nn', 'en'],
      'sms': ['nb', 'sv', 'en'],
      'smj': ['nb', 'sv', 'en'],
      'es': ['en', 'fr', 'nb', 'se'],
      'fr': ['en', 'es', 'nb', 'se'],
      'de': ['en', 'nb', 'se'],
      'pl': ['en'],
      'default': ['en']
    },
    ns: ["common", "db"],
    defaultNS: "common",
    lowerCaseLng: true,
    cleanCode: true,
    showSupportNotice: false,
    resources,
  });

export default i18n;
